import { server } from "../../server";
import { useEffect, useState } from "react";
import axios from "axios";
import ExportExcel from "../../components/ExportExcel";
import ExportPDF from "../../components/ExportPDF";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import * as XLSX from "xlsx";
import { capitalizeWords } from "../../functions";

function BusStoppage() {
  const [busStoppageDetails, setBusStoppageDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState("");
  const MySwal = withReactContent(Swal);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const recordsPerPage = 10;

  const [formData, setFormData] = useState({
    stoppage: "",
    April: 0,
    May: 0,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 0,
    November: 0,
    December: 0,
    January: 0,
    February: 0,
    March: 0,
  });

  const totalFields = Object.keys(formData).length;
  const filledFields = Object.values(formData).filter(
    (val) =>
      (typeof val === "string" && val.trim() !== "") ||
      (typeof val === "number" && val > 0)
  ).length;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      if (name === "monthlyFee") {
        const updatedMonths = {};
        Object.keys(prev).forEach((key) => {
          if (key !== "stoppage") {
            updatedMonths[key] = Number(value) || 0;
          }
        });

        return { ...prev, ...updatedMonths };
      }

      return {
        ...prev,
        [name]: value,
      };
    });

    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formattedData = {};
    Object.keys(formData).forEach((key) => {
      formattedData[key] =
        typeof formData[key] === "string"
          ? formData[key].trim()
          : formData[key];
    });

    setLoading(true);

    try {
      const response = await axios.post(
        `${server}/addBusStoppageMongoDb`,
        formData,
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Bus Stoppage Added", { position: "top-right" });
      const closeButton = document.querySelector('[data-bs-dismiss="modal"]');
      if (closeButton) {
        closeButton.click();
      }
      setFormData({
        stoppage: "",
        April: 0,
        May: 0,
        June: 0,
        July: 0,
        August: 0,
        September: 0,
        October: 0,
        November: 0,
        December: 0,
        January: 0,
        February: 0,
        March: 0,
      });
    } catch (error) {
      toast.error("Please Try Again", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    axios
      .get(`${server}/getAllBusStoppageMongoDb`, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        const stoppages = response.data?.["body-json"]?.body?.stoppages;
        if (Array.isArray(stoppages)) {
          setBusStoppageDetails(stoppages);
        } else {
          console.error("Invalid data format from API", response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("API Fetch Error:", error);
        setLoading(false);
      });
  }, []);

  // Filter
  const filteredRecords = busStoppageDetails.filter((driver) => {
    const searchLower = searchTerm.toLowerCase();

    return Object.values(driver).some((value) => {
      if (typeof value === "string") {
        return value.toLowerCase().includes(searchLower);
      } else if (typeof value === "object" && value !== null) {
        return Object.values(value).some(
          (subValue) =>
            typeof subValue === "string" &&
            subValue.toLowerCase().includes(searchLower)
        );
      }
      return false;
    });
  });

  // ✅ Reset pagination when searching
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // ✅ Apply pagination AFTER filtering
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  // Page Navigation
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const columnMapping = {
    stoppage: "Stoppage",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
    january: "January",
    february: "February",
    march: "March",
  };

  const handleExportExcel = () => {
    ExportExcel(busStoppageDetails, "BusStoppageDetails", columnMapping);
  };

  const handleExportPDF = () => {
    ExportPDF(busStoppageDetails, "BusStoppageDetails", columnMapping);
  };

  const handleDelete = async (stoppageToDelete) => {
    const result = await MySwal.fire({
      title: "Are you sure?",
      text: `Do you want to delete "${stoppageToDelete}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.post(
          `${server}/delete_busStoppage_mongodb`,
          { stoppage: stoppageToDelete },
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
            },
          }
        );

        if (response.status === 200) {
          toast.success("Bus Stoppage Deleted", { position: "top-right" });
          setBusStoppageDetails((prev) =>
            prev.filter((s) => s.stoppage !== stoppageToDelete)
          );
        } else {
          toast.error("Please Try Again");
        }
      } catch (error) {
        toast.error("Please Try Again");
      }
    }
  };

  const handleExportBusStoppageExcel = () => {
    if (!busStoppageDetails || busStoppageDetails.length === 0) {
      toast.error("No data to export");
      return;
    }

    const sheetData = busStoppageDetails.map((stoppage) => ({
      Stoppage: capitalizeWords(stoppage.stoppage || ""),
      April: stoppage.april || 0,
      May: stoppage.may || 0,
      June: stoppage.june || 0,
      July: stoppage.july || 0,
      August: stoppage.august || 0,
      September: stoppage.september || 0,
      October: stoppage.october || 0,
      November: stoppage.november || 0,
      December: stoppage.december || 0,
      January: stoppage.january || 0,
      February: stoppage.february || 0,
      March: stoppage.march || 0,
    }));

    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bus Stoppages");

    const today = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `BusStoppage_${today}.xlsx`);
    toast.success("Report Generated");
  };

  const handleExportBusStoppageSimilarFeeExcel = () => {
    if (!busStoppageDetails || busStoppageDetails.length === 0) {
      toast.error("No data to export");
      return;
    }

    const months = [
      "april",
      "may",
      "june",
      "july",
      "august",
      "september",
      "october",
      "november",
      "december",
      "january",
      "february",
      "march",
    ];

    const sheetData = [];

    months.forEach((month) => {
      const feeGroups = {};

      busStoppageDetails.forEach((stoppage) => {
        const fee = stoppage[month] || 0;
        if (!feeGroups[fee]) {
          feeGroups[fee] = [];
        }
        feeGroups[fee].push(capitalizeWords(stoppage.stoppage));
      });

      sheetData.push({ Month: capitalizeWords(month), Fee: "", Stoppage: "" });

      Object.entries(feeGroups).forEach(([fee, stoppages]) => {
        sheetData.push({ Month: "", Fee: fee, Stoppage: stoppages[0] });

        stoppages.slice(1).forEach((stoppage) => {
          sheetData.push({ Month: "", Fee: "", Stoppage: stoppage });
        });

        sheetData.push({ Month: "", Fee: "", Stoppage: "" });
      });

      sheetData.push({ Month: "", Fee: "", Stoppage: "" });
    });

    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Similar Fees");

    const today = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `BusStoppage_SimilarFee_${today}.xlsx`);
    toast.success("Report Generated");
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div
            class="modal fade gd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <form onSubmit={handleSubmit}>
                  <div class="modal-header d-flex justify-content-between">
                    <h5 class="modal-title fs-4" id="exampleModalToggleLabel">
                      Add Bus Stoppage{" "}
                      <span className="ms-3 text-secondary">
                        ({String(filledFields).padStart(2, "0")}/
                        {String(totalFields).padStart(2, "0")})
                      </span>
                    </h5>
                    <div className="d-flex align-items-center">
                      <span class="badge bg-success-soft me-3 px-3">
                        Editable
                      </span>
                      <div class="form-check form-switch me-4">
                        <input
                          type="checkbox"
                          class="form-check-input m-0"
                          checked
                        />
                      </div>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                  </div>

                  <div class="modal-body">
                    <div className="row g-2 mb-2">
                      <div className="col-lg-6 col-12">
                        <label class="form-label mb-1 ms-3">
                          Stoppage <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="stoppage"
                          className={`form-control text-dark ${
                            errors.stoppage ? "border-danger" : ""
                          }`}
                          placeholder="Enter Stoppage"
                          value={formData.stoppage}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-lg-6 col-12">
                        <label className="form-label mb-1 ms-3">
                          Monthly Fee <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          name="monthlyFee"
                          className="form-control text-dark"
                          placeholder="Enter Monthly Fee"
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer d-flex justify-content-between py-2">
                    <div>
                      <button
                        type="button"
                        class="btn btn-secondary px-3 me-1 rounded-pill"
                        data-bs-dismiss="modal"
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                      <button
                        type="submit"
                        class="btn btn-primary px-5 rounded-pill fw-normal"
                        disabled={loading}
                      >
                        {loading ? (
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="">
            <div class="container-fluid my-3 px-3">
              <div className="row g-2">
                <div className="col-lg-8">
                  <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
                    <table class="table mb-0 text-nowrap table-centered">
                      <thead class="table-light">
                        <tr>
                          <th className="w-10">No.</th>
                          <th className="lh-1 w-60">
                            Details
                            <i className="bi bi-info-circle ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Displaying Information as per Record
                            </span>
                          </th>
                          <th className="lh-1 w-30">
                            Action
                            <i className="bi bi-person-gear ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Role-Specific Action Panel
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRecords.map((stoppage, index) => (
                          <tr key={index}>
                            <td>{indexOfFirstRecord + index + 1}.</td>
                            <td className="lh-sm py-4 text-wrap text-capitalize">
                              <span class="text-dark">Stoppage</span> &mdash;{" "}
                              {stoppage.stoppage}
                              <hr className="w-25" />
                              <span class="text-dark">April</span> &mdash;{" "}
                              {stoppage.april} <br />
                              <span class="text-dark">May</span> &mdash;{" "}
                              {stoppage.may} <br />
                              <span class="text-dark">June</span> &mdash;{" "}
                              {stoppage.june} <br />
                              <span class="text-dark">July</span> &mdash;{" "}
                              {stoppage.july} <br />
                              <span class="text-dark">August</span> &mdash;{" "}
                              {stoppage.august} <br />
                              <span class="text-dark">
                                September
                              </span> &mdash; {stoppage.september} <br />
                              <span class="text-dark">
                                October
                              </span> &mdash; {stoppage.october} <br />
                              <span class="text-dark">
                                November
                              </span> &mdash; {stoppage.november} <br />
                              <span class="text-dark">
                                December
                              </span> &mdash; {stoppage.december} <br />
                              <span class="text-dark">
                                January
                              </span> &mdash; {stoppage.january} <br />
                              <span class="text-dark">
                                February
                              </span> &mdash; {stoppage.february} <br />
                              <span class="text-dark">March</span> &mdash;{" "}
                              {stoppage.march}
                            </td>
                            <td>
                              <div className="d-flex flex-column gap-1 width-fit-content">
                                <span class="badge bg-success-soft cursor-pointer px-4 rounded-3 btn-py-sm">
                                  Update
                                </span>
                                <span
                                  onClick={() =>
                                    handleDelete(stoppage.stoppage)
                                  }
                                  class="badge bg-danger-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                >
                                  Delete
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div class="">
                    <div className="mb-3">
                      <div className="d-flex bg-white justify-content-between rounded-4">
                        <form
                          className="d-flex align-items-center"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <span className="position-absolute ps-3 search-icon">
                            <i className="bi bi-filter-circle-fill ms-1" />
                          </span>
                          <input
                            type="search"
                            className="form-control ps-7 rounded-3 border-0 rounded-4"
                            placeholder="Filter Data"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </form>
                        <Link
                          data-bs-toggle="modal"
                          data-bs-target=".gd-example-modal-lg"
                          class="btn btn-warning px-5 fs-6 fw-medium rounded-4 fit-content"
                        >
                          Add Stoppage
                        </Link>
                      </div>
                      <div className="mt-2 ms-4">
                        <nav aria-label="breadcrumb">
                          <ol class="breadcrumb pe-3">
                            <li class="breadcrumb-item">
                              <a href="#">Transport Management</a>
                            </li>
                            <li
                              class="breadcrumb-item active"
                              aria-current="page"
                            >
                              Bus Stoppage
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>

                    <div className="p-4 bg-white rounded-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          {loading ? (
                            <div
                              className="spinner-border text-dark data-loader-spinner"
                              role="status"
                            ></div>
                          ) : (
                            <img src="/assets/images/folder.svg" />
                          )}

                          <p className="my-0 fw-semibold lh-1 fs-5 text-dark mx-3">
                            Bus Stoppage
                            <br />
                            <span className="text-secondary fs-6 fw-medium lh-sm">
                              1.4 MB Size
                            </span>
                          </p>
                        </div>
                        <span
                          onClick={handleExportExcel}
                          className="badge bg-pink rounded-3 px-4 py-2 me-1 mt-1 cursor-pointer"
                        >
                          Export
                        </span>
                      </div>

                      <div class="px-4 py-2 mt-3 bg-light rounded-4">
                        <li className="list-group-item px-0">
                          <a
                            className="d-flex align-items-center text-inherit mb-0 justify-content-between"
                            data-bs-toggle="collapse"
                            href="#specifications"
                            role="button"
                            aria-expanded="false"
                            aria-controls="specifications"
                          >
                            <p className="m-0 fw-medium lh-sm text-dark">
                              Download Report
                            </p>
                            <span className="chevron-arrow ms-4">
                              <i className="bi bi-chevron-down fs-4" />
                            </span>
                          </a>
                          <div
                            className="collapse"
                            id="specifications"
                            data-bs-parent="#ecommerceAccordion"
                          >
                            <div className="py-3">
                              <div class="rounded-4 d-flex flex-wrap">
                                <span
                                  onClick={handleExportBusStoppageExcel}
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  All Stoppage
                                </span>
                                <span
                                  onClick={
                                    handleExportBusStoppageSimilarFeeExcel
                                  }
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  Similar Transport Fee Stoppage
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>

                    <div className="my-4">
                      <nav>
                        <ul className="pagination justify-content-center mb-0">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={prevPage}>
                              <i className="bi bi-chevron-left"></i>
                            </button>
                          </li>

                          {(() => {
                            const pageNumbers = [];
                            pageNumbers.push(1);

                            if (currentPage > 3) {
                              pageNumbers.push("left-ellipsis");
                            }

                            if (
                              currentPage !== 1 &&
                              currentPage !== totalPages
                            ) {
                              pageNumbers.push(currentPage);
                            }

                            if (currentPage < totalPages - 2) {
                              pageNumbers.push("right-ellipsis");
                            }

                            if (totalPages > 1) {
                              pageNumbers.push(totalPages);
                            }

                            return pageNumbers.map((page, index) => {
                              if (
                                page === "left-ellipsis" ||
                                page === "right-ellipsis"
                              ) {
                                return (
                                  <li
                                    key={index}
                                    className="page-item disabled"
                                  >
                                    <span className="page-link">...</span>
                                  </li>
                                );
                              }

                              return (
                                <li
                                  key={index}
                                  className={`page-item ${
                                    currentPage === page ? "active" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(page)}
                                  >
                                    {page}
                                  </button>
                                </li>
                              );
                            });
                          })()}

                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={nextPage}>
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default BusStoppage;
